import styled from "styled-components";

export const LockWrapper = styled.div`
  position: absolute;
  inset: 0 0 0 0;
  background-color: rgba(200, 200, 200, 0.6);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;

  :hover {
    cursor: ${(p) => (p.disabled ? "" : "pointer")};
    background-color: ${(p) => (p.disabled ? "" : "rgba(230, 230, 230, 0.6)")};
  }
`;

export const LockHeader = styled.h2``;

export const MapContainer = styled.div`
  position: relative;
`;

export const Wrapper = styled.div`
  width: min(400px, 70%);
  position: absolute;
  z-index: 1;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;

  @media (max-width: 600px) {
    left: 50dvw;
    width: min(200px, 70%);
  }

  @media (max-width: 768px) {
    left: 50dvw;
    width: min(250px, 70%);
  }

  @media (max-width: 992px) {
    left: 50%;
    width: min(300px, 70%);
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  padding: 0 20px;
  background-color: #fff;
  border-radius: ${(p) => (p.showSuggestions ? "20px 20px 0 0" : "40px")};
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 50px;
  border: none;

  &:focus {
    outline: none;
  }

  &[disabled] {
    background-color: #fff;
  }
`;

export const SearchIcon = styled.i`
  color: #ccc;
`;

export const ClearIcon = styled(SearchIcon)`
  &:hover {
    cursor: pointer;
    color: lightblue;
  }
`;

export const ClearButton = styled.button`
  background-color: #fff;
  border: none;
  border-radius: 2px;

  &:focus {
    outline: 0;
  }

  &:focus-visible {
    outline: 2px solid blue;
  }
`;

export const SuggestionsWrapper = styled.div`
  display: flex;
  width: 100%;
  max-height: 15vh;
`;

export const SuggestionsList = styled.ul`
  border: 1px solid #ccc;
  width: 100%;
  list-style: none;
  padding: 0;
  overflow: auto;
  background-color: #fff;
`;

export const Suggestion = styled.li`
  padding: 10px;

  &:hover {
    background-color: #eee;
    cursor: pointer;
  }

  &.disabled:hover {
    background-color: #fff;
  }

  &:focus {
    background-color: #eee;
    outline: none;
  }
`;

export const Container = styled.div`
  background-color: white;
  min-height: 100px;
  max-height: 600px;
  overflow: auto;
`;

export const CheckBoxItemContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Checkbox = styled.div`
  width: 16px;
  height: 16px;
  background: ${(p) => (p.checked ? "#404e67" : "white")};
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  cursor: pointer;
`;

export const CheckboxLabel = styled.p`
  margin: 0 5px;
`;

export const ListItemContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ArrowIcon = styled.div`
  transform: rotate(${(p) => (p.expanded ? "180" : 0)}deg);
  cursor: pointer;
`;

export const LayerSelectorContainer = styled.div`
  display: grid;
`;

export const LayerSelectorLabel = styled.h4`
  position: sticky;
  top: 0px;
  background-color: #fff;
  z-index: 1;
  padding: 5px 10px;
`;

export const SaveButton = styled.button`
  position: absolute;
  bottom: 12px;
  right: 12px;
  padding: 6px;
  background-color: steelblue;
  color: white;

  :disabled {
    opacity: 0.8;
  }
`;

export const SaveInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
